import { getAxiosInstance } from '@/services/axiosConfig';
import { Model } from '@/types/nodes/model';

const axiosInstance = getAxiosInstance();

export const getReplicateModelVersionParams = async (modelToFetch: Model) => {
  const res = await axiosInstance.get<{ openapi_schema: Record<string, unknown> }>(
    `/v1/models/replicate/${modelToFetch.name}/${modelToFetch.version}`,
  );
  return res.data;
};

export const getReplicateModelVersionByName = async (replicateModelId: string) => {
  const res = await axiosInstance.get<{
    description: string;
    cover_image_url: string;
    latest_version: { id: string };
  }>(`/v1/models/replicate/${replicateModelId}`);
  return res.data;
};
